export const REQUEST_PROFILE = "REQUEST_PROFILE";
export const RECEIVE_PROFILE = "RECEIVE_PROFILE";
export const PROFILE_ERROR = "PROFILE_ERROR";

export const requestProfile = () => ({
  type: REQUEST_PROFILE
});

export const receiveProfile = json => ({
  type: RECEIVE_PROFILE,
  user: json.data
});

export const profileError = err => ({
  type: PROFILE_ERROR,
  error: err
});

export function fetchProfile() {
  return function (dispatch, getState) {
    dispatch(requestProfile());

    const state = getState();
    const { webtoken } = state.prerequisites;

    return fetch(`/api/v1/profile`, {
      headers: {
        Authorization: `Bearer ${webtoken}`
      }
    })
      .then(
        response => response.json(),
        error => dispatch(profileError(error))
      )
      .then(json => {
        dispatch(receiveProfile(json));
      })
      .catch(function (error) {
        dispatch(profileError(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/profile.js